import React from "react";
import Scroll from "scroll-js/dist/scroll";
import {
  Card,
  CardImg,
  CardText,
  CardBody,
  CardTitle,
  Button,
  Col,
  Row
} from "reactstrap";

const scrollToContact = event => {
  const scroll = new Scroll(document.body);
  event.preventDefault();
  const targetElement = document.querySelector(".home--contact");
  scroll.toElement(targetElement, { duration: 500 });
};

const Approach = () => {
  return (
    <Row className="justify-content-around">
      <Col sm="10" md="10" lg="10" className="approach--header">
        <h3>Our Approach</h3>
        <p>
          We are a full-stack web development agency employing forcibly
          displaced people as software developers. We believe that Tech for Good
          starts with the individuals writing the code behind digital services.
          We empower people from all ethnicities by offering them their first
          professional job in tech.
        </p>
      </Col>
      <Col sm="10" md="5" lg="5">
        <Card body inverse>
          <CardImg
            top
            width="100%"
            src="/images/ux-inclusive-labs.jpg"
            alt="MVP and UX"
          />
          <CardBody>
            <CardTitle>MVP & UX </CardTitle>
            <CardText>
              Do you have an idea that you are itching to build? Do you want to
              nail down your product?
            </CardText>
            <Button color="primary" size="md" onClick={scrollToContact}>
              Contact Us <i class="fas fa-caret-down"> </i>
            </Button>
          </CardBody>
        </Card>
      </Col>

      <Col sm="10" md="5" lg="5">
        <Card body inverse>
          <CardImg
            top
            width="100%"
            src="/images/consultation-inclusive-labs.jpg"
            alt="Consultation"
          />
          <CardBody>
            <CardTitle>CONSULTATION</CardTitle>
            {/* <CardSubtitle>Card subtitle</CardSubtitle> */}
            <CardText>
              We can provide consultation and in-house training session on how
              to adopt new technologies.
            </CardText>
            <Button color="primary" size="md" onClick={scrollToContact}>
              Contact Us <i class="fas fa-caret-down"> </i>
            </Button>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default Approach;



// WEBPACK FOOTER //
// ./src/pages/Home/Approach.js